import { render, staticRenderFns } from "./InputRadio.vue?vue&type=template&id=240b3722"
import script from "./InputRadio.vue?vue&type=script&lang=js"
export * from "./InputRadio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/al-khaleej/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('240b3722')) {
      api.createRecord('240b3722', component.options)
    } else {
      api.reload('240b3722', component.options)
    }
    module.hot.accept("./InputRadio.vue?vue&type=template&id=240b3722", function () {
      api.rerender('240b3722', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/global/InputRadio.vue"
export default component.exports